export const FORM_NAME = 'sortForm'

export const SORT_BY_INPUT_NAME = 'sortBy'
export const SORT_BY_INPUT_LABEL = 'Sort by'
